'use client';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Button } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { colors } from '@/styles/theme';

interface WhatsAppAuthButtonProps {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}

export const WhatsAppAuthButton = ({
  onClick,
  disabled = false,
  label = 'Continue with WhatsApp',
}: WhatsAppAuthButtonProps) => (
  <Button
    fullWidth
    variant="contained"
    disableElevation
    startIcon={<WhatsAppIcon sx={{ fontSize: 20 }} />}
    onClick={onClick}
    disabled={disabled}
    sx={(theme) => ({
      py: 1.25,
      borderRadius: 2.5,
      textTransform: 'none',
      fontWeight: 600,
      fontSize: '0.875rem',
      letterSpacing: '0.01em',
      mb: 1,
      bgcolor: colors.brand.whatsapp,
      color: 'white',
      border: '1px solid',
      borderColor: 'transparent',
      boxShadow: `0 1px 3px ${alpha(theme.palette.common.black, 0.08)}`,
      transition: 'background-color 0.2s ease, transform 0.1s active',
      '&:hover': {
        bgcolor: alpha(colors.brand.whatsapp, 0.9),
      },
      '&:active': {
        transform: 'scale(0.99)',
      },
      '&.Mui-disabled': {
        bgcolor: 'action.disabledBackground',
        color: 'action.disabled',
      },
    })}
  >
    {label}
  </Button>
);
